/* ========================================
   CHEFSTYLE — Shopify JavaScript
   Cart AJAX + UI interactions
======================================== */

// ---- CART DRAWER ----
function openCart() {
  refreshCart();
  document.getElementById('cart-drawer').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.body.style.overflow = '';
}

function refreshCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      updateCartCount(cart.item_count);
      document.getElementById('cart-subtotal-price').textContent = formatMoney(cart.total_price);
      const el = document.getElementById('cart-drawer-items');
      if (cart.item_count === 0) {
        el.innerHTML = '<p class="cart-empty">Votre panier est vide.</p>';
      } else {
        el.innerHTML = cart.items.map(item => `
          <div class="drawer-item">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" class="drawer-item-img">` : ''}
            <div class="drawer-item-info">
              <div class="drawer-item-name">${item.product_title}</div>
              ${item.variant_title !== 'Default Title' ? `<div class="drawer-item-variant">${item.variant_title}</div>` : ''}
              <div class="drawer-item-price">${formatMoney(item.final_line_price)}</div>
              <div class="drawer-item-qty">
                <button onclick="updateCartItem('${item.key}', ${item.quantity - 1})">−</button>
                <span>${item.quantity}</span>
                <button onclick="updateCartItem('${item.key}', ${item.quantity + 1})">+</button>
              </div>
            </div>
          </div>
        `).join('');
      }
    });
}

function updateCartCount(count) {
  const el = document.getElementById('cart-count');
  if (el) el.textContent = count;
}

function updateCartItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(r => r.json())
  .then(cart => {
    updateCartCount(cart.item_count);
    refreshCart();
  });
}

function formatMoney(cents) {
  return Math.floor(cents / 100).toLocaleString('fr-DZ') + ' DA';
}

// ---- ADD TO CART AJAX ----
document.addEventListener('DOMContentLoaded', function() {
  // Intercept all ATC forms
  document.querySelectorAll('.atc-form, #product-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      const orig = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Ajout...'; btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt(form.querySelector('[name="quantity"]')?.value || 1)
        })
      })
      .then(r => r.json())
      .then(item => {
        if (btn) { btn.textContent = '✓ Ajouté !'; }
        refreshCart();
        setTimeout(() => openCart(), 300);
        setTimeout(() => {
          if (btn) { btn.textContent = orig; btn.disabled = false; }
        }, 2000);
      })
      .catch(() => {
        if (btn) { btn.textContent = orig; btn.disabled = false; }
      });
    });
  });
});

// ---- PRODUCT PAGE VARIANT SELECTOR ----
function selectOption(el, optionName, value) {
  // Deselect siblings
  document.querySelectorAll(`.option-btn[data-option="${optionName}"]`).forEach(b => b.classList.remove('selected'));
  el.classList.add('selected');
  updateVariant();
}

function updateVariant() {
  const selected = {};
  document.querySelectorAll('.option-btn.selected').forEach(b => {
    selected[b.dataset.option] = b.dataset.value;
  });
  if (typeof variantData === 'undefined') return;
  const match = variantData.find(v =>
    v.options.every((opt, i) => selected[v.option_names[i]] === opt || Object.values(selected).length === 0)
  );
  if (match) {
    document.getElementById('selected-variant').value = match.id;
    const priceEl = document.querySelector('.prod-price');
    if (priceEl) priceEl.textContent = formatMoney(match.price);
  }
}

// ---- QTY SELECTOR ----
function changeQty(delta) {
  const input = document.getElementById('qty-input');
  if (!input) return;
  const val = Math.max(1, parseInt(input.value) + delta);
  input.value = val;
}

// ---- PRODUCT GALLERY ----
function changeImage(src, thumb) {
  const main = document.getElementById('main-img');
  if (main) main.src = src;
  document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
  if (thumb) thumb.classList.add('active');
}

// ---- STICKY NAV SHADOW ----
window.addEventListener('scroll', function() {
  const nav = document.getElementById('main-nav');
  if (nav) nav.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,.08)' : '';
});

// ---- BURGER MENU (MOBILE) ----
function toggleBurger() {
  const menu = document.getElementById('mobile-menu');
  const overlay = document.getElementById('mobile-overlay');
  const burger = document.getElementById('burger-btn');
  if (!menu) return;
  const isOpen = menu.classList.toggle('open');
  if (overlay) overlay.classList.toggle('open', isOpen);
  if (burger) burger.classList.toggle('active', isOpen);
  document.body.style.overflow = isOpen ? 'hidden' : '';
}

// Close mobile menu on ESC
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    const menu = document.getElementById('mobile-menu');
    if (menu && menu.classList.contains('open')) toggleBurger();
  }
});
